import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { Schema } from 'features/performance/pages/PerformanceYieldbirdDemandPage/forms/AdminOptionForm/schema'
import type { UpdateYieldbirdDemandReportUrlMutationVariables } from 'gql/graphql'

type From = Schema
type To = UpdateYieldbirdDemandReportUrlMutationVariables['input']

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ id, yieldbirdDemandReportUrl }: From): To => ({
      id,
      yieldbirdDemandReportUrl: yieldbirdDemandReportUrl || null,
    }),
  )
